import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { Container } from "./styles";
export const GroupSubscriberTooltip = ({
  message,
  onImpression
}) => {
  useMountEffect(() => {
    onImpression();
  });
  return /*#__PURE__*/React.createElement(Container, {
    dangerouslySetInnerHTML: {
      __html: message
    },
    "data-qa": "group-subscriber-tooltip"
  });
};
GroupSubscriberTooltip.displayName = "GroupSubscriberTooltip";